const project_name =
  process.env.REACT_APP_ENV === "dev"
    ? "AscendLogoDev"
    : process.env.REACT_APP_PROJECT;

export let logo = `${process.env.REACT_APP_AWS_URL}assets/projects_logo/${project_name}.svg`;
export let logoSVG = `${process.env.REACT_APP_AWS_URL}assets/projects_logo/${project_name}__logo.svg`;
export let background = `${process.env.REACT_APP_AWS_URL}assets/projects_background/${project_name}.svg`;
